import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  // Wait until loading completes
  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner
  }

  // Redirect unauthenticated users
  if (!user) {
    return <Navigate to="/Login" />;
  }

  // Redirect unauthorized users
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
